// import $ from 'jquery'
import _ from 'underscore'
import Backbone from 'backbone'
import { $ajax } from '../utils/ajax'
import Logger from 'Logger'

/**
 * @typedef {Object} AllListModelAttributes
 * @property {number} purchaseLimit - 사용자의 구매 한도.
 * @property {string} trackingCode - 분석 또는 식별을 위한 트래킹 코드.
 * @property {number} pmangCash - 사용 가능한 피망 캐시 금액.
 * @property {Array} decoration - 데코레이션 아이템 목록.
 * @property {Array} emoticon - 이모티콘 아이템 목록.
 * @property {Array} items - 일반 아이템 목록.
 * @property {Array} pokerclass - 포커 클래스 아이템 목록.
 * @property {Array} hotdeal - 핫딜 아이템 목록.
 * @property {Array<{
 *   bonus_money_rate?: number,
 *   coupon_name?: string,
 *   vip_coupon_id?: number
 * }>} vip_coupon_info - VIP 쿠폰 정보.
 * @property {string} gameName - 게임 이름.
 * @property {number} vipGrade - VIP 등급 (1~4: VIP, 5: 일반).
 * @property {boolean} hasVipCoupons - VIP 쿠폰 보유 여부.
 */

/**
 * 상품 정보 리스트
 * @type Backbone.Model<AllListModelAttributes>
 */
export var AllListModel = Backbone.Model.extend({
  defaults: function () {
    return {
      purchaseLimit: 0,
      trackingCode: '',
      pmangCash: 0,
      decoration: [],
      emoticon: [],
      items: [],
      pokerclass: [],
      hotdeal: [],
      vip_coupon_info: [
        // bonus_money_rate: number;
        // coupon_name: string;
        // vip_coupon_id: number;
      ],
      // 여기에 포커홈이 렌더링하는 .app__initiali-state 값이 합쳐짐
      gameName: '',
      vipGrade: 0, // VIP 1 ~ 4 등급, 5는 일반

      // 모델 parse 후 생성
      // VIP 쿠폰을 가지고 있는지?
      hasVipCoupons: false,
    }
  },
  generateGoodsArray: function (goods) {
    var goodsArray = []
    if (_.isArray(goods)) {
      for (var i = 0; i < goods.length; i++) {
        goodsArray.push({ goods_id: goods[i] })
      }
    } else {
      goodsArray.push({ goods_id: goods })
    }
    return goodsArray
  },
  parse: function (res) {
    var appState = $('.app__initial-state')

    // VIP 쿠폰 : 서버 데이터에 없으면 null
    var vipCouponInfo = _.isArray(res.result.vip_coupon_info)
      ? res.result.vip_coupon_info
      : []

    var parsed = _.extend(res.result, {
      vip_coupon_info: vipCouponInfo,
      hasVipCoupons: vipCouponInfo.length > 0,
      gameName: appState.data('game'),
      vipGrade: appState.data('vipGrade'),
    })

    Logger.info('All goods list parsed:', parsed)
    return parsed
  },
  sync: function (method, model, options) {
    if (method === 'read') {
      // NOTE: mock
      // return options.success({ mock })

      $ajax('/list', null, 'GET')
        .done(function (res) {
          options.success(res)
          if (options.reload) {
            routie.reload()
          }
        })
        .fail(function (error) {
          options.error(error)
        })
    }
  },
})

/**
 * @type Backbone.Model<AllListModelAttributes>
 */
export var allListModel = new AllListModel()
